import { get, first, template } from 'lodash';
import fetchWithCache from './fetchWithCache';

const getFeaturedContentUrls = (data, modelInfo) => {
  const { brand, brandVariant, isFleet } = modelInfo;
  const contents = get(data, isFleet ? brandVariant : brand);
  const typesMap = {
    featuredPromo: '1',
    featuredSubscription: '2',
  };
  const getDataByType = (type) =>
    contents &&
    contents.filter((content) => content.position === typesMap[type]);

  return {
    featuredPromoUrl: get(first(getDataByType('featuredPromo')), 'url', ''),
    featuredSubscriptionUrl: get(
      first(getDataByType('featuredSubscription')),
      'url',
      ''
    ),
  };
};

export const fetchFeaturedContentTemplate = (url, modelInfo, type) => {
  if (!url) {
    return '';
  }

  const { country, carline, bodyStyle, year } = modelInfo;
  const key = `${country}-${year}-${carline}-${bodyStyle}-FEATURED_CONTENT-${type}`;
  let cache = window.__cache__;

  if (cache.has(key)) {
    return Promise.resolve(cache.get(key));
  }

  const options = {
    mode: 'no-cors',
    headers: new Headers({ 'content-type': 'text/html;charset=UTF-8' }),
  };

  return fetch(url, options)
    .then((response) => {
      return response.text();
    })
    .then((template) => {
      cache.set(key, template);
      return template;
    });
};

export const fetchFeaturedContentUrls = (urlTemplate, modalInfo) => {
  if (!urlTemplate) {
    return Promise.resolve();
  }

  const {
    brand,
    brandVariant,
    region,
    country,
    language,
    carline,
    bodyStyle,
    year,
  } = modalInfo;

  const url = template(urlTemplate)({
    brand: brandVariant || brand,
    region,
    country,
    language,
    carline,
    bodyStyle,
    year,
  });

  return fetchWithCache(url)
    .then((data) => {
      const urls = getFeaturedContentUrls(data, modalInfo);
      return urls;
    })
    .catch(() => null);
};
